import { formatPercent } from "@angular/common";
import { ContentTable } from "pdfmake/interfaces";
import { BallotReport } from "./ballot-report";
import { reportLayoutNames } from "./report-layouts";
import { reportStyleNames } from "./report-styles";
import { SrsBallotVoteTypes } from "../sr/srs-ballot-vote-type";

export class SrsBallotReport extends BallotReport {
  override committeeVoteColumns: string[] = [
    'Committee Member',
    'Organisation',
    'Role',
    'Country',
    'Voting Rights',
    'Answer to Q1',
    'Answer to Q2'
  ];

  override ballotVoteResultColumns: string[] = [
    'Ballot Result',
    'Total',
    SrsBallotVoteTypes.SVT_RECONFIRM.name,
    SrsBallotVoteTypes.SVT_REVISE.name,
    SrsBallotVoteTypes.SVT_WITHDRAW.name,
    SrsBallotVoteTypes.SVT_NONE.name
  ];

  consensusCriteriaColumns = [
    '67% Consensus Criteria',
    SrsBallotVoteTypes.SVT_RECONFIRM.name,
    SrsBallotVoteTypes.SVT_REVISE.name,
    SrsBallotVoteTypes.SVT_WITHDRAW.name,
    SrsBallotVoteTypes.SVT_NONE.name
  ];

  constructor() {
    super();
  }

  override generateBallotVoteResultBreakdownTable(): ContentTable | null {
    let content = super.generateBallotVoteResultBreakdownTable();
    if (content) {
      content.table.widths = ['20%', '10%', '17.5%', '17.5%', '17.5%', '17.5%'];
    }

    return content;
  }

  override generateConsensusCriteriaBreakdownTable(): ContentTable | null {
    if (!this.consensusCriteriaColumns || (this.voteResultBreakdown?.length ?? 0) < 1) {
      return null;
    }

    return {
      table: {
        body: [
          this.consensusCriteriaColumns.map(x => { return { text: x, style: reportStyleNames.tableHeader } }),
          ...this.voteResultBreakdown.map(x => {
            return [
              { text: x.country },
              ...x.votePercentages.map(v => ({ text: formatPercent(v.percentage, 'en', '1.0-2'), fillColor: v.fillColor }))
            ]
          })
        ],
        widths: ['30%', '17.5%', '17.5%', '17.5%', '17.5%']
      },
      layout: reportLayoutNames.outerBordersTable
    };
  }

  override generateCommitteeVotesTable(): ContentTable | null{
    let content = super.generateCommitteeVotesTable();
    if (content) {
      content.table.widths = ['20%', '30%', '15%', '10%', '9%', '8%', '8%'];
    }

    return content;
  }
}
